import {Controller, useFormContext} from "react-hook-form";
import {FormControl, FormHelperText, MenuItem, Select} from "@mui/material";
import {ZyusetuFieldKeyFragmentFragment, ZyusetuFieldKeyType,} from "@/graphql/graphql";
import {FormSchema} from "@/components/pages/Zyusetu/ZyusetuEditorSection.tsx";
import {zyusetuValueIntoZodValue} from "@/hooks/useGetFirstContent";

interface ZyusetuSelectFieldProps {
  fieldKey: ZyusetuFieldKeyFragmentFragment;
  onFocus: () => void;
  updateField: (
    keyId: string,
    keyName: string,
    value: FormSchema<ZyusetuFieldKeyType.Select>[string],
  ) => Promise<void>;
  isAvailable: boolean;
}

export function ZyusetuSelectField({
                                     fieldKey,
                                     onFocus,
                                     updateField,
                                     isAvailable,
                                   }: ZyusetuSelectFieldProps) {
  const {control} = useFormContext<FormSchema<ZyusetuFieldKeyType.Select>>();
  return (
    <Controller
      name={fieldKey.keyName}
      control={control}
      render={({field, formState: {errors}, fieldState: {isDirty}}) => (
        <FormControl
          fullWidth
          error={!!errors?.[fieldKey.keyName]?.value?.message}
        >
          <Select
            inputRef={field.ref}
            onFocus={onFocus}
            {...field}
            disabled={!isAvailable}
            value={field.value.value || ""}
            size={"small"}
            onBlur={async () => {
              if (errors?.[fieldKey.keyName]?.value?.message) return;
              if (!isDirty) return;
              
              await updateField(fieldKey.id, fieldKey.keyName, field.value);
            }}
            onChange={(e) => {
              field.onChange(
                zyusetuValueIntoZodValue(fieldKey, e.target.value),
              );
            }}
            renderValue={(value) => value}
          >
            {fieldKey.items?.map((option) => (
              <MenuItem key={`${fieldKey.id}-select-${option}`} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
          {errors?.[fieldKey.keyName]?.value?.message &&
            <FormHelperText style={{color: "red"}}>
              {errors?.[fieldKey.keyName]?.value?.message || ""}
            </FormHelperText>}
        </FormControl>
      )}
    />
  );
}
